import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white recent-activity-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_4 = { class: "text-black fw-bold" }
const _hoisted_5 = { class: "d-block fs-13 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-15 mb-md-20 mb-xxxl-25 d-flex align-itemsh5s-center justify-content-between" }, [
        _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Activité récente")
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "position-relative fw-medium text-dark-emphasis",
            key: item.id
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
              _createElementVNode("i", { class: "ph-duotone ph-check-circle" })
            ], -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.task_type) + " #" + _toDisplayString(item.task_code), 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(item.task) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getDate(item.created_at)), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}